export const FetchClient = async (endpoint: string, options: RequestInit) => {
  const response = await fetch(`${endpoint}`, {
    headers: {
      'Content-Type': 'application/json', // 내용 형식을 JSON으로 지정합니다.
    },
    ...options,
  });

  if (!response.ok) {
    let res = await response.json();
    throw new Error(res.error || 'Network response was not ok');
  }

  return response.json(); // 응답 본문을 JSON 형태로 파싱합니다.
};
